export * from './course/course.model';
export * from './schoolClass/schoolClass.model';
export * from './user/user.model';
export * from './token/token.model';
export * from './assigment/assigment.model';
export * from './thumbnail/thumbnail.model';
export * from './error/error.model';